import {
  FeedbackDetailResponseSelectedOption,
  InterviewFeedbackQuestionType,
} from 'models/enum';
import { IFeedbackDetailsResponseItems } from './candidateFeedbackDetailList.model';

export interface IFeedbackOverallSelectedOptions {
  Yes: number;
  No: number;
  Unsure: number;
}

export interface ICandidateInterviewFeedbackOverallRating {
  version: number;
  isSuccess: boolean;
  overallScore: string;
  interviewFeedbacksReceived: number;
  interviewerDetails: null | string;
  agreegateResponse: ICandidateFeedbackOverallResponse;
  successMessage: string;
  errorMessage: null | string;
  statusCode: number;
}

export interface ICandidateFeedbackOverallResponse {
  responseItemList: ICandidateFeedbackResponseItem[];
}

export interface ICandidateFeedbackResponseItem {
  name: string;
  label: string;
  questionType: string;
  score: string;
  textComment: string | null;
  selectedOptions: ICandidateFeedbackSelectedOptions;
  selectedOption: null;
}

interface ICandidateFeedbackSelectedOptions {
  yes: string;
  no: string;
  notSure: string;
}

export const areAllRatingsNA = (
  feedbackDetailsResponseItems?: IFeedbackDetailsResponseItems[],
  responseItems?: ICandidateFeedbackResponseItem[]
) => {
  let likartWithNaItems: (
    | IFeedbackDetailsResponseItems
    | ICandidateFeedbackResponseItem
  )[] = [];

  if (responseItems) {
    likartWithNaItems = responseItems.filter(
      (item) =>
        item.questionType === InterviewFeedbackQuestionType.LIKART_WITH_NA
    );
  } else if (feedbackDetailsResponseItems) {
    likartWithNaItems = feedbackDetailsResponseItems.filter(
      (item) =>
        item.questionType === InterviewFeedbackQuestionType.LIKART_WITH_NA
    );
  }
  const propertyName = responseItems ? 'score' : 'selectedOption';
  return likartWithNaItems.every(
    (item) =>
      (item as any)[propertyName] === FeedbackDetailResponseSelectedOption.NA
  );
};
